import { useCallback, useState } from 'react';

export const useBoolean = () => {
  const [value, setValue] = useState(false);
  const toggleValue = useCallback(() =>  setValue((prev) => !prev), []);
  return [value, toggleValue, setValue] as const;
};
